import { render, staticRenderFns } from "./InvoicesTabComponent.vue?vue&type=template&id=ff0a8adc&scoped=true&lang=pug"
import script from "./InvoicesTabComponent.vue?vue&type=script&lang=ts"
export * from "./InvoicesTabComponent.vue?vue&type=script&lang=ts"
import style0 from "./InvoicesTabComponent.vue?vue&type=style&index=0&id=ff0a8adc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0a8adc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff0a8adc')) {
      api.createRecord('ff0a8adc', component.options)
    } else {
      api.reload('ff0a8adc', component.options)
    }
    module.hot.accept("./InvoicesTabComponent.vue?vue&type=template&id=ff0a8adc&scoped=true&lang=pug", function () {
      api.rerender('ff0a8adc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/billing/InvoicesTab/InvoicesTabComponent.vue"
export default component.exports